<template>
	<div>
		<el-button style="margin-bottom: 20px;" type="primary" @click="setsu('null')">添加</el-button>
		<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" border stripe
			@selection-change="handleSelectionChange">
			<el-table-column label="名称" align="center" prop="reason"></el-table-column>
			<el-table-column label="时间" align="center" prop="createTime"></el-table-column>
			<el-table-column prop="icon" align="center" fixed="right" label="操作">
				<template slot-scope="scope">
					<template> <el-button type="success" plain slot="reference" @click="setsu(scope.row)">编辑</el-button>
					</template>
					<template v-if="hasAuth('sys:coupons:delete')">
						<el-popconfirm title="确定删除该退款原因？" @confirm="delHandle(scope.row.id)">
							<el-button type="danger" plain slot="reference">删除</el-button>
						</el-popconfirm>
					</template>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
			<el-form>
				<el-form-item label="名称">
					<el-input v-model="reason" placeholder="请输入名称" clearable></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="setdialog(id, 2)">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: 'Coupons',
	components: {},
	data() {
		return {
			searchForm: {},
			delBtlStatu: true,
			tableData: [],
			multipleSelection: [],
			total: 0,
			size: 10,
			current: 1,
			addUpdateCouponsvisible: false,
			getCouponsUserssvisible: false,
			dialogVisible: false,
			id: '',
			reason: ''
		}
	},
	created() {
		this.getCoupons()
	},
	methods: {
		handleClose() {
			this.dialogVisible = false
		},
		setsu(e) {
			if (e == 'null') {
				this.id = ''
				this.reason = ''
			} else {
				this.id = e.id
				this.reason = e.reason
			}
			this.dialogVisible = true
		},
		setdialog(e) {
			if (this.id == '') {
				this.$axios
					.post('/admin/billReturnReason/addBillReturnReason', {
						reason: this.reason
					})
					.then((res) => {
						this.getCoupons()
						this.dialogVisible = false
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
							onClose: () => {

							},
						})
					})
			} else {
				this.$axios
					.post('/admin/billReturnReason/updBillReturnReason', {
						id: this.id,
						reason: this.reason
					})
					.then((res) => {
						this.getCoupons()
						this.dialogVisible = false
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
							onClose: () => { },
						})
					})
			}
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row)
				})
			} else {
				this.$refs.multipleTable.clearSelection()
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			this.size = val
			this.getCoupons()
		},
		handleCurrentChange(val) {
			this.current = val
			this.getCoupons()
		},

		getCoupons() {

			this.$axios
				.post('/admin/billReturnReason/getBillReturnReasonList', this.searchForm)
				.then((res) => {
					this.tableData = res.data

				})
		},

		//删除资讯
		delHandle(id) {
			this.$axios
				.post('/admin/billReturnReason/delBillReturnReason', {
					id: id
				})
				.then((res) => {
					this.getCoupons()
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose: () => {

						},
					})
				})
		},



	},
}
</script>

<style scoped>
.el-button {
	padding: 0 10px;
	height: 35px;
	line-height: 35px;
	font-size: 15px;
	margin-right: 10px;
}
</style>